import React from "react";
import ProjectsSection from "../components/Projects";
import Footer from "../components/Footer";
import "../css/style.css";
import ProjectsIntro from "../components/ProjectsIntro";
import ProjectsList from "../components/ProjectsList";
function Projects() {
  return (
    <div>
        
    <ProjectsIntro />
    <ProjectsList />
    <Footer />
    </div>
    
    
  );
}

export default Projects;
